import React from "react";
import {
  Grid,
  GridItem,
  Image,
  Box,
  HStack,
  Text,
  Heading,
  Divider,
  VStack,
  Button,
  useDisclosure,
  Link,
} from "@chakra-ui/react";
import { ArrowRightIcon } from "./icons/ArrowRight";
import { ReservaIcon } from "./icons/ReservaIcon";
import TourModal from "./TourModal";
import { motion } from "framer-motion";
import { opacityVariants } from "../utils/animations";

import { useContext } from "react";
import { LanguajeContext } from "../App";

const ImagenCuadro = ({
  headerText,
  headerNumber,
  title1,
  title2,
  texto,
  variant,
  horarios,
  duracion,
  reserva,
  modalType,
  imagen,
  href,
  titleImage,
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { lang } = useContext(LanguajeContext);

  if (variant === "salentein") {
    return (
      <Grid templateColumns={{ lg: "repeat(2,1fr)", xs: "repeat(1,1fr)" }}>
        <GridItem order={{ lg: 1, xs: 2 }}>
          <Image
            src={imagen}
            objectFit={"cover"}
            w="100%"
            boxSize={"100%"}
          ></Image>
        </GridItem>
        <GridItem backgroundColor={"crema"} order={{ lg: 2, xs: 1 }}>
          <Box
            className="center"
            px={{ xl: 28, lg: 20, xs: 8 }}
            py={{ xl: 0, lg: 8, xs: 20 }}
          >
            <motion.div
              variants={opacityVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              <VStack alignItems={"flex-start"}>
                <img src="./img/salentein-logo.png" alt="" />
                <Box py={5}>
                  <Text
                    fontSize={"16px"}
                    mt="0"
                    lineHeight={"24px"}
                    fontWeight={"300"}
                    letterSpacing="0.01em"
                    color={"calliaGray"}
                    fontFamily={"'Montserrat', sans-serif"}
                  >
                    {texto}
                  </Text>
                </Box>
              </VStack>
            </motion.div>
          </Box>
        </GridItem>
      </Grid>
    );
  }
  if (variant === "noButton") {
    return (
      <Grid templateColumns={{ lg: "repeat(2,1fr)", xs: "repeat(1,1fr)" }}>
        <GridItem order={{ lg: 1, xs: 2 }}>
          <Image
            src={imagen}
            objectFit={"cover"}
            w="100%"
            boxSize={"100%"}
          ></Image>
        </GridItem>
        <GridItem backgroundColor={"crema"} order={{ lg: 2, xs: 1 }}>
          <Box
            className="center"
            px={{ xl: 28, lg: 20, xs: 8 }}
            py={{ xl: 0, lg: 8, xs: 20 }}
          >
            <motion.div
              variants={opacityVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              <VStack alignItems={"flex-start"}>
                <Heading
                  size={"2xl"}
                  fontFamily={"'Playfair Display', serif"}
                  color={"rojo"}
                >
                  {title1}
                  <Text fontStyle={"italic"} fontWeight={"700"}>
                    {title2}
                  </Text>
                </Heading>
                <Box py={5}>
                  <Text
                    fontSize={"16px"}
                    mt="0"
                    lineHeight={"24px"}
                    fontWeight={"300"}
                    letterSpacing="0.01em"
                    color={"calliaGray"}
                    fontFamily={"'Montserrat', sans-serif"}
                  >
                    {texto}
                  </Text>
                </Box>
              </VStack>
            </motion.div>
          </Box>
        </GridItem>
      </Grid>
    );
  }

  if (variant === "evento") {
    return (
      <Grid templateColumns={{ lg: "repeat(2,1fr)", xs: "repeat(1,1fr)" }}>
        <GridItem order={{ lg: 1, xs: 2 }}>
          <Image src={imagen} objectFit={"cover"} w="100%" boxSize={"100%"} />
        </GridItem>
        <GridItem background={"crema"} order={{ lg: 2, xs: 1 }}>
          <Box
            className="center"
            px={{ xl: 28, lg: 20, xs: 8 }}
            py={{ xl: 0, lg: 8, xs: 20 }}
            flexDirection={"column"}
            alignItems={"flex-start"}
          >
            <motion.div
              variants={opacityVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              <Heading
                fontSize={"35px"}
                fontWeight={"700"}
                lineHeight={{ lg: "24px", xs: "32px" }}
                fontFamily={"'Playfair Display', serif"}
                color={"rojo"}
                fontStyle={"italic"}
                pb={5}
              >
                {title1}
              </Heading>
              <Text
                fontSize={"14px"}
                lineHeight={"22px"}
                fontWeight={"400"}
                color={"calliaGray"}
                fontFamily={"'Montserrat', sans-serif"}
                pb={5}
              >
                {texto}
              </Text>
              <Text
                fontSize={{ md: "12px", lg: "12px", xs: "12px" }}
                lineHeight={"24px"}
                fontStyle={"italic"}
                fontFamily={"Montserrat"}
                pb={4}
              >
                <strong>
                  Consultar disponibilidad, opciones y presupuestos:
                </strong>{" "}
                <br />
                WhatsApp 2645064021 o info.bodegascallia@salentein.com{" "}
              </Text>
              <Button
                colorScheme={"calliaRed"}
                variant="solid"
                borderRadius={"0px"}
                fontSize={"14px"}
                leftIcon={<ReservaIcon />}
                onClick={onOpen}
                _hover={{ backgroundColor: "#580C0C" }}
              >
                RESERVAR TOUR
              </Button>
            </motion.div>
          </Box>
        </GridItem>
        <TourModal
          isOpen={isOpen}
          onClose={onClose}
          onOpen={onOpen}
          type={modalType}
        />
      </Grid>
    );
  }

  if (variant === "tour") {
    return (
      <Grid templateColumns={{ lg: "repeat(2,1fr)", xs: "repeat(1,1fr)" }}>
        <GridItem order={{ lg: 1, xs: 2 }}>
          <Image
            src={imagen}
            objectFit={"cover"}
            w="100%"
            boxSize={"100%"}
          ></Image>
        </GridItem>
        <GridItem background={"crema"} order={{ lg: 2, xs: 1 }}>
          <Box
            className="center"
            px={{ xl: 28, lg: 20, xs: 8 }}
            py={{ xl: 0, lg: 8, xs: 20 }}
          >
            <motion.div
              variants={opacityVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              <VStack alignItems={"flex-start"}>
                <Heading
                  fontSize={"35px"}
                  fontWeight={"700"}
                  lineHeight={{ lg: "24px", xs: "32px" }}
                  fontFamily={"'Playfair Display', serif"}
                  color={"rojo"}
                  fontStyle={"italic"}
                  pb={5}
                >
                  {title1}
                </Heading>
                <Text
                  fontSize={"14px"}
                  lineHeight={"22px"}
                  fontWeight={"400"}
                  color={"calliaGray"}
                  fontFamily={"'Montserrat', sans-serif"}
                  pb={5}
                >
                  <span dangerouslySetInnerHTML={{ __html: texto }} />
                </Text>

                <Box>
                  {horarios ? (
                    <Text
                      fontSize={"12px"}
                      lineHeight={"22px"}
                      fontStyle={"italic"}
                      fontWeight={"bold"}
                      fontFamily={"'Montserrat', sans-serif"}
                      color={"calliaGray"}
                    >
                      {lang ? "Available days:" : "Días disponibles:"}
                    </Text>
                  ) : (
                    ""
                  )}

                  <Text
                    fontSize={{ md: "12px", lg: "12px" }}
                    lineHeight={"22px"}
                    fontStyle={"italic"}
                  >
                    {horarios}
                  </Text>
                </Box>
                <Text
                  fontSize={"12px"}
                  lineHeight={"22px"}
                  fontStyle={"italic"}
                  fontFamily={"'Montserrat', sans-serif"}
                  color={"calliaGray"}
                >
                  {duracion && (
                    <strong>
                      {lang ? "Duration:" : "Duración:"}{" "}
                      <span className="fw400">{duracion} </span>
                    </strong>
                  )}
                </Text>
                <Text
                  fontSize={"12px"}
                  lineHeight={"24px"}
                  fontFamily={"Montserrat"}
                >
                  {reserva}
                </Text>
                <Box pb={5}>
                  <Text
                    fontSize={"12px"}
                    lineHeight={"22px"}
                    fontStyle={"italic"}
                    fontWeight={"bold"}
                    fontFamily={"'Montserrat', sans-serif"}
                    color={"calliaGray"}
                  >
                    {lang
                      ? "Inquiries about cost, days and hours:"
                      : "Consultas sobre costo, días y horarios:"}
                  </Text>
                  <Text
                    fontSize={{ md: "12px", lg: "12px", xs: "12px" }}
                    lineHeight={"24px"}
                    fontStyle={"italic"}
                    fontFamily={"Montserrat"}
                  >
                    {lang
                      ? "WhatsApp: 2645064021 or info.bodegascallia@salentein.com"
                      : "WhatsApp: 2645064021 o info.bodegascallia@salentein.com"}
                  </Text>
                </Box>
                <Button
                  colorScheme={"calliaRed"}
                  variant="solid"
                  borderRadius={"0px"}
                  fontSize={"14px"}
                  leftIcon={<ReservaIcon />}
                  onClick={onOpen}
                  _hover={{ backgroundColor: "#580C0C" }}
                >
                  {lang ? "BOOK TOUR" : "RESERVAR TOUR"}
                </Button>
              </VStack>
            </motion.div>
          </Box>
        </GridItem>
        <TourModal
          isOpen={isOpen}
          onClose={onClose}
          onOpen={onOpen}
          type={modalType}
        />
      </Grid>
    );
  }

  return (
    <Grid templateColumns={{ xs: "repeat(1,1fr)", lg: "repeat(2, 1fr)" }}>
      <GridItem order={{ lg: 1, xs: 2 }}>
        <Image
          src={imagen}
          objectFit={"cover"}
          w="100%"
          boxSize={"100%"}
        ></Image>
      </GridItem>
      <GridItem backgroundColor={"crema"} order={{ lg: 2, xs: 1 }}>
        <motion.div
          variants={opacityVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
        >
          <Box position={"relative"} p={{ xs: 12, "2xl": 32 }}>
            <VStack alignItems={"flex-start"}>
              <HStack
                justifyContent="space-between"
                w={"100%"}
                color={"#9A1515"}
                alignItems={"center"}
              >
                <Text fontSize={"md"} fontFamily={"Montserrat, sans-serif"}>
                  {headerText}
                </Text>
                <Divider
                  orientation={"horizontal"}
                  borderColor={"rgba(147, 20, 20, 1)"}
                  maxW={"25vw"}
                />
                <Text
                  fontSize={"60px"}
                  fontWeight={"600"}
                  fontFamily={"'Playfair Display', serif"}
                  m={0}
                >
                  {headerNumber}.
                </Text>
              </HStack>
              <Heading
                size={"2xl"}
                fontFamily={"'Playfair Display', serif"}
                fontWeight={"600"}
                color={"#9A1515"}
              >
                {title1}
                <Text fontStyle={"italic"} fontWeight={"700"}>
                  {title2}
                </Text>
              </Heading>
              <Box py={{ xs: 5, "2xl": 12 }}>
                <Text
                  fontSize={"16px"}
                  lineHeight={"24px"}
                  mt="0"
                  color={"#393835"}
                  fontFamily={"'Montserrat', sans-serif"}
                >
                  {texto}
                </Text>
              </Box>
            </VStack>
            <Link
              href={href}
              textDecoration={"none"}
              _hover={{ textDecoration: "none" }}
            >
              <Button
                height={"35px"}
                letterSpacing={"0.07em"}
                colorScheme="black"
                variant="outline"
                borderRadius={0}
                rightIcon={<ArrowRightIcon />}
                mt={10}
                textTransform={"uppercase"}
                fontSize={"sm"}
                _hover={{
                  backgroundColor: "#ecd5c0 ",
                  color: "#000",
                  border: "1px solid transparent",
                }}
              >
                {lang ? "See more" : "Ver mas"}
              </Button>
            </Link>
          </Box>
        </motion.div>
      </GridItem>
    </Grid>
  );
};

export default ImagenCuadro;
